import { toast } from 'react-toastify';
import { Api } from '../lib/api/api';
import utils from '../lib/utils';
import { SOMETHING_WENT_WRONG } from './Users';

export const getCompanies = (
  token,
  pagination,
  disablePaginate,
  type,
  getDeleted,
  onlyNames,
) => async dispatch => {
  const api = new Api(token);
  dispatch({
    type: 'GET_COMPANIES',
  });
  try {
    // if (!onlyNames) throw "bla bla bla"
    if (typeof onlyNames === 'undefined') onlyNames = disablePaginate === 'yes';
    const companies = await api.companies.getCompanies(
      pagination,
      'yes',
      type,
      getDeleted,
      onlyNames,
    );
    dispatch({
      type: 'GET_COMPANIES_SUCCESS',
      companies,
    });
    return companies;
  } catch (error) {
    dispatch({
      type: 'GET_COMPANIES_ERROR',
      error,
    });
  }
};

export const getCompanyGroup = (token, cid) => async dispatch => {
  const api = new Api(token);
  dispatch({
    type: 'GET_COMPANY_GROUP',
  });
  try {
    const companyGroup = await api.companies.getCompanyGroup(cid);
    dispatch({
      type: 'GET_COMPANY_GROUP_SUCCESS',
      companyGroup,
    });
    return companyGroup;
  } catch (error) {
    dispatch({
      type: 'GET_COMPANY_GROUP_ERROR',
      error,
    });
  }
};

export const getPriBoxesByCompany = (token, cid) => async dispatch => {
  const api = new Api(token);
  dispatch({
    type: 'GET_PRI_BOXES_BY_COMPANY',
  });
  try {
    const boxes = await api.companies.getPriBoxesByCompany(cid);
    console.log("geted boxes ", boxes)
    dispatch({
      type: 'GET_PRI_BOXES_BY_COMPANY_SUCCESS',
      boxes,
    });
    return boxes;
  } catch (error) {
    dispatch({
      type: 'GET_PRI_BOXES_BY_COMPANY_ERROR',
      error,
    });
  }
}

export const getSipBoxesByCompany = (token, cid) => async dispatch => {
  const api = new Api(token);
  dispatch({
    type: 'GET_SIP_BOXES_BY_COMPANY',
  });
  try {
    const boxes = await api.companies.getSipBoxesByCompany(cid);
    dispatch({
      type: 'GET_SIP_BOXES_BY_COMPANY_SUCCESS',
      boxes,
    });
    return boxes;
  } catch (error) {
    dispatch({
      type: 'GET_SIP_BOXES_BY_COMPANY_ERROR',
      error,
    });
  }
}

export const getCompanyAgency = (
  token,
  pagination,
  disablePaginate,
  type = 'agency',
) => async dispatch => {
  const api = new Api(token);
  dispatch({
    type: 'GET_COMPANY_AGENCY',
  });
  try {
    const companyAgency = await api.companies.getCompanies(pagination, 'yes', type);
    dispatch({
      type: 'GET_COMPANY_AGENCY_SUCCESS',
      companyAgency,
    });
  } catch (error) {
    dispatch({
      type: 'GET_COMPANY_AGENCY_ERROR',
      error,
    });
  }
};

export const getAllCompanies = (
  token,
  pagination,
  disablePaginate,
  type = 'all',
) => async dispatch => {
  const api = new Api(token);
  dispatch({
    type: 'GET_COMPANIES',
  });
  try {
    const companiesList = await api.companies.getCompanies(pagination, disablePaginate, type);
    dispatch({
      type: 'GET_COMPANIES_LIST_SUCCESS',
      companiesList,
    });
  } catch (error) {
    dispatch({
      type: 'GET_COMPANIES_ERROR',
      error,
    });
  }
};

export const getAllCompaniesByGroupAction = (token, id) => async dispatch => {
  const api = new Api(token);
  try {
    const companiesList = await api.companies.getCompaniesByGroupApi(id);
    dispatch({
      type: 'GET_COMPANIES_LIST_SUCCESS',
      companiesList,
    });
  } catch (error) {
    dispatch({
      type: 'GET_COMPANIES_ERROR',
      error,
    });
  }
};

export const getAllCompanyGroups = (
  token,
  pagination,
  paginateResult = true,
  onlyName,
) => async dispatch => {
  const api = new Api(token);
  dispatch({
    type: 'GET_COMPANY_GROUPS',
  });
  try {
    const companyGroupList = await api.companies.getCompanyGroups(
      pagination,
      paginateResult,
      undefined,
      onlyName,
    );
    if (!paginateResult) {
      dispatch({
        type: 'GET_COMPANY_GROUP_DROPDOWN_LIST',
        payload: companyGroupList,
      });
    } else {
      dispatch({
        type: 'GET_COMPANY_GROUPS_LIST_SUCCESS',
        companyGroupList,
      });
    }
  } catch (error) {
    dispatch({
      type: 'GET_COMPANY_GROUPS_ERROR',
      error,
    });
  }
};

export const getAllEnterpriseAdmins = (token, pagination, filters = { name: '', company: '' }) => async dispatch => {
  const api = new Api(token);
  dispatch({
    type: 'GET_ENTERPRISE_ADMINS',
  });
  try {
    const enterpriseAdmins = await api.companies.getEnterpriseAdmins(pagination, filters);

    dispatch({
      type: 'GET_ENTERPRISE_ADMINS_SUCCESS',
      enterpriseAdmins,
    });
  } catch (error) {
    dispatch({
      type: 'GET_ENTERPRISE_ADMINS_ERROR',
      error,
    });
  }
};

export const addEnterpriseAdmins = (token, body) => async dispatch => {
  const api = new Api(token);
  dispatch({
    type: 'ADD_ENTERPRISE_ADMINS',
  });
  try {
    const enterpriseAdmins = await api.companies.addEnterpriseAdmins(body);

    dispatch({
      type: 'ADD_ENTERPRISE_ADMINS_SUCCESS',
      enterpriseAdmins,
    });
  } catch (error) {
    dispatch({
      type: 'ADD_ENTERPRISE_ADMINS_ERROR',
      error,
    });
  }
};

export const getCompanyGroupManager = (token, id, uid, type, gflag) => async dispatch => {
  const api = new Api(token);
  dispatch({
    type: 'COMPANY_GROUP_MANAGER',
  });
  try {
    const groupManagerEmail = await api.numbers.getCompanyNumbers(id, uid, type, gflag);
    dispatch({
      type: 'COMPANY_GROUP_MANAGER_SUCCESS',
      groupManagerEmail,
    });
    return groupManagerEmail;
  } catch (error) {
    return dispatch({
      type: 'COMPANY_GROUP_MANAGER_ERROR',
      error,
    });
  }
};

export const getSupportEngineers = (token, id, uid, type, gflag) => async dispatch => {
  const api = new Api(token);
  dispatch({
    type: 'COMPANY_SUPPORT_ENGINEERS',
  });
  try {
    const groupSupportEngineer = await api.numbers.getCompanyNumbers(id, uid, type, gflag);
    dispatch({
      type: 'COMPANY_SUPPORT_ENGINEERS_SUCCESS',
      groupSupportEngineer,
    });
    return groupSupportEngineer;
  } catch (error) {
    return dispatch({
      type: 'COMPANY_SUPPORT_ENGINEERS_ERROR',
      error,
    });
  }
};

export const filterCompanies = (
  token,
  company,
  pagination,
  disablePaginate,
  type,
) => async dispatch => {
  const api = new Api(token);
  dispatch({
    type: 'GET_COMPANIES',
  });
  try {
    const companies = await api.companies.filterCompanies(
      company,
      pagination,
      disablePaginate,
      type,
    );
    dispatch({
      type: 'GET_COMPANIES_SUCCESS',
      companies,
    });
    dispatch({
      type: 'GET_COMPANIES_LIST_SUCCESS',
      companiesList: companies,
    });
  } catch (error) {
    dispatch({
      type: 'GET_COMPANIES_ERROR',
      error,
    });
  }
};

export const addCompany = (token, company) => async dispatch => {
  company.permissions = {
    emailNotifications:
      company.emailNotifications === undefined ? false : company.emailNotifications,
    showCallRecording: company.showCallRecording === undefined ? false : company.showCallRecording,
    showFaxDownload: company.showFaxDownload === undefined ? false : company.showFaxDownload,
  };

  const api = new Api(token);
  const isPhoneNumberValid = company?.contactPerson?.phone?.length
    ? utils.verifyPhoneNumber(company?.contactPerson?.phone)
    : true;
  if (isPhoneNumberValid) {
    dispatch({
      type: 'ADD_COMPANY',
      company,
    });

    try {
      const addedCompany = await api.companies.addCompany(company);
      dispatch({
        type: 'ADD_COMPANY_SUCCESS',
        company: addedCompany,
      });
      dispatch({
        type: 'CLEAR_COMPANY_CHANGE',
      });
      toast.success('Company created successfully.', {
        toastId: 'CLEAR_COMPANY_CHANGE',
      });
    } catch (error) {
      if (error.response) {
        toast.error(error.response.data, {
          toastId: 'ADD_COMPANY_FAILURE',
        });
      }
      dispatch({
        type: 'ADD_COMPANY_FAILURE',
        error,
      });
      dispatch({
        type: 'CLEAR_COMPANY_CHANGE',
      });
    }
  }
};

export const addCompanyGroup = (token, company) => async dispatch => {
  const api = new Api(token);
  dispatch({
    type: 'ADD_COMPANY',
    company,
  });
  try {
    const companyGroup = await api.companies.addCompanyGroup(company);
    dispatch({
      type: 'ADD_COMPANY_GROUP_SUCCESS',
      companyGroup,
    });
    dispatch({
      type: 'CLEAR_COMPANY_GROUP_CHANGE',
    });
    toast.success('Company created successfully.', {
      toastId: 'CLEAR_COMPANY_GROUP_CHANGE',
    });
  } catch (error) {
    toast.error(error.response.data || SOMETHING_WENT_WRONG);
    dispatch({
      type: 'ADD_COMPANY_GROUP_FAILURE',
      error,
    });
    // dispatch({
    //   type: 'CLEAR_COMPANY_GROUP_CHANGE',
    // });
  }
};

export const addEnterpriseGroup = (token, company) => async dispatch => {
  const api = new Api(token);
  dispatch({
    type: 'ADD_ENTERPRISE',
    company,
  });
  try {
    const enterpriseGroup = await api.companies.addEnterpriseGroup(company);
    dispatch({
      type: 'ADD_ENTERPRISE_GROUP_SUCCESS',
      enterpriseGroup,
    });
    dispatch({
      type: 'CLEAR_ENTERPRISE_GROUP_CHANGE',
    });
    toast.success('Enterprise created successfully.', {
      toastId: 'CLEAR_ENTERPRISE_GROUP_CHANGE',
    });
  } catch (error) {
    toast.error(error.response.data || SOMETHING_WENT_WRONG);
    dispatch({
      type: 'ADD_ENTERPRISE_GROUP_FAILURE',
      error,
    });
  }
};

// Add Company dialog UI actions
export const showAddCompany = id => dispatch => {
  dispatch({
    type: 'ADD_COMPANY_SHOW',
    id,
  });
  dispatch({
    type: 'CLEAR_COMPANY_CHANGE',
  });
};

export const showAddCompanyGroup = id => dispatch => {
  dispatch({
    type: 'CLEAR_COMPANY_GROUP_CHANGE',
  });
  dispatch({
    type: 'ADD_COMPANY_GROUP_SHOW',
    id,
  });
};

export const showAddEnterpriseGroup = id => dispatch => {
  dispatch({
    type: 'CLEAR_ENTERPRISE_GROUP_CHANGE',
  });
  dispatch({
    type: 'ADD_ENTERPRISE_GROUP_SHOW',
    id,
  });
};

export const cancelAddCompany = () => dispatch => {
  dispatch({
    type: 'ADD_COMPANY_CANCEL',
  });
};

export const cancelAddCompanyGroup = () => dispatch => {
  dispatch({
    type: 'ADD_COMPANY_GROUP_CANCEL',
  });
  dispatch(getCompanies(localStorage.getItem('jwtToken'), undefined, 'yes', 'none'));
};

export const cancelAddEnterpriseGroup = () => dispatch => {
  dispatch({
    type: 'ADD_ENTERPRISE_GROUP_CANCEL',
  });
  dispatch(getCompanies(localStorage.getItem('jwtToken'), undefined, 'yes', 'none'));
};

export const addCompanyChange = companyData => dispatch => {
  dispatch({
    type: 'ADD_COMPANY_CHANGE',
    name: companyData.name,
    value: companyData.value,
    valueFor: companyData.type || null,
  });
};

export const addCompanyGroupChange = companyData => dispatch => {
  dispatch({
    type: 'ADD_COMPANY_GROUP_CHANGE',
    name: companyData.name,
    value: companyData.value,
  });
};

export const addEnterpriseGroupChange = companyData => dispatch => {
  dispatch({
    type: 'ADD_ENTERPRISE_GROUP_CHANGE',
    name: companyData.name,
    value: companyData.value,
  });
};

export const deleteCompany = (token, id) => async dispatch => {
  const api = new Api(token);
  dispatch({
    type: 'DELETE_COMPANY',
    id,
  });
  try {
    const deletedCompany = await api.companies.deleteCompany(id);
    dispatch({
      type: 'DELETE_COMPANY_SUCCESS',
      deletedCompany,
    });
    dispatch({
      type: 'DELETE_COMPANY_CANCEL',
    });
    toast.success(`Company Deleted Successfully`);
    return deletedCompany;
  } catch (error) {
    dispatch({
      type: 'DELETE_COMPANY_FAILURE',
      error,
    });
    dispatch({
      type: 'DELETE_COMPANY_CANCEL',
    });
    toast.error(error.response.data || SOMETHING_WENT_WRONG);
  }
};

export const deleteCompanyGroup = (token, id, hardDelete) => async dispatch => {
  const api = new Api(token);
  dispatch({
    type: 'DELETE_COMPANY_GROUP',
    id,
  });
  try {
    const deletedCompany = await api.companies.deleteCompanyGroup(id, hardDelete);
    dispatch({
      type: 'DELETE_COMPANY_GROUP_SUCCESS',
      deletedCompany,
    });
    dispatch({
      type: 'DELETE_COMPANY_CANCEL',
    });
    toast.success(`Company Group Deleted Successfully`);
    return true;
  } catch (error) {
    dispatch({
      type: 'DELETE_COMPANY_GROUP_FAILURE',
      error,
    });
    dispatch({
      type: 'DELETE_COMPANY_CANCEL',
    });
    toast.error(error.response.data || SOMETHING_WENT_WRONG);
  }
};

// Delete Company dialog UI actions
export const showDeleteCompany = id => dispatch => {
  dispatch({
    type: 'DELETE_COMPANY_SHOW',
    id,
  });
};

// Delete Enterprise dialog UI actions
export const showDeleteEnterprise = id => dispatch => {
  dispatch({
    type: 'DELETE_ENTERPRISE_SHOW',
    id,
  });
};

export const cancelDeleteCompany = () => dispatch => {
  dispatch({
    type: 'DELETE_COMPANY_CANCEL',
  });
};

export const cancelDeleteEnterprise = () => dispatch => {
  dispatch({
    type: 'DELETE_ENTERPRISE_CANCEL',
  });
};

// Edit Company dialog UI actions
export const showEditCompany = data => dispatch => {
  dispatch({
    type: 'EDIT_COMPANY_SHOW',
  });

  dispatch({
    type: 'EDIT_COMPANY_DATA',
    data,
  });
};

export const showEditCompanyGroup = data => dispatch => {
  dispatch({
    type: 'EDIT_COMPANY_GROUP_SHOW',
  });
  dispatch({
    type: 'CLEAR_EDIT_COMPANY_GROUP_DATA',
  });

  dispatch({
    type: 'EDIT_COMPANY_GROUP_DATA',
    data,
  });
};

export const showEditEnterpriseAdmin = data => dispatch => {
  dispatch({
    type: 'EDIT_ENTERPRISE_GROUP_SHOW',
  });
  dispatch({
    type: 'CLEAR_EDIT_ENTERPRISE_GROUP_DATA',
  });

  dispatch({
    type: 'EDIT_ENTERPRISE_GROUP_DATA',
    data,
  });
};

export const cancelEditCompany = () => dispatch => {
  dispatch({
    type: 'EDIT_COMPANY_CANCEL',
  });
};

export const cancelEditCompanyGroup = () => dispatch => {
  dispatch({
    type: 'EDIT_COMPANY_GROUP_CANCEL',
  });
  dispatch(getCompanies(localStorage.getItem('jwtToken'), undefined, 'yes', 'none'));
};

export const cancelEditEnterpriseAdmin = () => dispatch => {
  dispatch({
    type: 'EDIT_ENTERPRISE_GROUP_CANCEL',
  });
  dispatch(getCompanies(localStorage.getItem('jwtToken'), undefined, 'yes', 'none'));
};

export const updateCompany = (token, id, companyData) => async dispatch => {
  companyData.permissions = {
    emailNotifications:
      companyData.emailNotifications === undefined ? false : companyData.emailNotifications,
    showCallRecording:
      companyData.showCallRecording === undefined ? false : companyData.showCallRecording,
    showFaxDownload:
      companyData.showFaxDownload === undefined ? false : companyData.showFaxDownload,
  };
  const api = new Api(token);
  dispatch({
    type: 'UPDATE_COMPANY',
  });
  try {
    const updatedCompany = await api.companies.updateCompany(id, companyData);
    dispatch({
      type: 'UPDATE_COMPANY_SUCCESS',
      updatedCompany,
    });
    toast.success(`Company Updated Successfully`, {
      toastId: 'UPDATE_COMPANY_SUCCESS',
    });
    dispatch({
      type: 'EDIT_COMPANY_CANCEL',
    });
    dispatch({
      type: 'CLEAR_COMPANY_CHANGE',
    });
  } catch (error) {
    dispatch({
      type: 'UPDATE_COMPANY_ERROR',
      error,
    });
    toast.error(error.response.data || SOMETHING_WENT_WRONG);
    dispatch({
      type: 'EDIT_COMPANY_CANCEL',
    });
    dispatch({
      type: 'CLEAR_COMPANY_CHANGE',
    });
  }
};

export const onRecover = (token, copmanyID) => async dispatch => {
  const api = new Api(token);
  dispatch({
    type: 'RECOVER_COMPANY',
  });
  try {
    await api.companies.onRecover(copmanyID);
    dispatch({
      type: 'RECOVER_COMPANY_SUCCESS',
    });
    toast.success('Company Recovered Successfully!');
    return true;
  } catch (error) {
    dispatch({
      type: 'RECOVER_COMPANY_FAILURE',
      error,
    });
    toast.error(error.response.data || `Error in recovering Company`);
  }
};

export const onRecoverCompanyGroup = (token, copmanyID) => async dispatch => {
  const api = new Api(token);
  dispatch({
    type: 'RECOVER_COMPANY_GROUP',
  });
  try {
    await api.companies.onRecoverCompanyGroup(copmanyID);
    dispatch({
      type: 'RECOVER_COMPANY_GROUP_SUCCESS',
    });
    toast.success('Company Group Recovered Successfully!');
    return true;
  } catch (error) {
    dispatch({
      type: 'RECOVER_COMPANY_GROUP_FAILURE',
      error,
    });
    toast.error(error.response.data || `Error in recovering Company Group`);
  }
};

export const updateCompanyGroup = (token, id, companyData) => async dispatch => {
  // companyData['permissions'] = {
  //   emailNotifications: companyData.emailNotifications || false,
  //   showCallRecording: companyData.showCallRecording || false,
  // }
  const api = new Api(token);
  dispatch({
    type: 'UPDATE_COMPANY_GROUP',
  });
  try {
    const updatedCompany = await api.companies.updateCompanyGroup(id, companyData);
    dispatch({
      type: 'UPDATE_COMPANY_GROUP_SUCCESS',
      updatedCompany,
    });
    toast.success(`Company Group Updated Successfully`, {
      toastId: 'UPDATE_COMPANY_GROUP_SUCCESS',
    });
    dispatch({
      type: 'EDIT_COMPANY_GROUP_CANCEL',
    });
    dispatch({
      type: 'CLEAR_COMPANY_GROUP_CHANGE',
    });
  } catch (error) {
    dispatch({
      type: 'UPDATE_COMPANY_GROUP_ERROR',
      error,
    });
    toast.error(error.response.data, {
      toastId: 'UPDATE_COMPANY_GROUP_ERROR',
    });
    dispatch({
      type: 'EDIT_COMPANY_GROUP_CANCEL',
    });
    dispatch({
      type: 'CLEAR_COMPANY_GROUP_CHANGE',
    });
  }
};

export const updateEnterpriseAdmin = (token, companyData) => async dispatch => {
  const api = new Api(token);
  dispatch({
    type: 'UPDATE_ENTERPRISE_GROUP',
  });
  try {
    const updatedCompany = await api.companies.updateEnterpriseAdmin(companyData);
    dispatch({
      type: 'UPDATE_ENTERPRISE_GROUP_SUCCESS',
      updatedCompany,
    });
    dispatch({
      type: 'DELETE_ENTERPRISE_CANCEL',
    });
    toast.success(`Company Group Updated Successfully`, {
      toastId: 'UPDATE_ENTERPRISE_GROUP_SUCCESS',
    });
    dispatch({
      type: 'EDIT_ENTERPRISE_GROUP_CANCEL',
    });
    dispatch({
      type: 'CLEAR_ENTERPRISE_GROUP_CHANGE',
    });
  } catch (error) {
    dispatch({
      type: 'UPDATE_ENTERPRISE_GROUP_ERROR',
      error,
    });
    toast.error(error.response.data, {
      toastId: 'UPDATE_ENTERPRISE_GROUP_ERROR',
    });
    dispatch({
      type: 'EDIT_ENTERPRISE_GROUP_CANCEL',
    });
    dispatch({
      type: 'CLEAR_ENTERPRISE_GROUP_CHANGE',
    });
  }
};

export const setCompanyStatus = (token, id, status) => async dispatch => {
  const api = new Api(token);
  dispatch({
    type: 'SET_COMPANY_STATUS',
    status,
    id,
  });
  try {
    const changedCompany = await api.companies.setCompanyStatus(id, status);
    dispatch({
      type: 'SET_COMPANY_STATUS_SUCCESS',
      changedCompany,
    });
    return changedCompany;
  } catch (error) {
    dispatch({
      type: 'SET_COMPANY_STATUS_FAILURE',
      error,
    });
  }
};

export const addCompanyLogo = (token, id, files) => async dispatch => {
  const api = new Api(token);
  dispatch({
    type: 'ADD_COMPANY_LOGO',
  });
  try {
    const addCompanyLogo = await api.companies.addCompanyLogo(id, files);
    dispatch({
      type: 'ADD_COMPANY_LOGO_SUCCESS',
      addCompanyLogo,
    });
    toast.success('Company Logo upload Successfully!');
    return addCompanyLogo;
  } catch (error) {
    dispatch({
      type: 'ADD_COMPANY_LOGO_FAILURE',
      error,
    });
    toast.error(error.response.data || SOMETHING_WENT_WRONG);
  }
};

export const getLogo = (token, id) => async dispatch => {
  const api = new Api(token);
  dispatch({
    type: 'GET_COMPANY_LOGO',
  });
  try {
    const getCompanyLogo = await api.companies.getLogo(id);
    dispatch({
      type: 'GET_COMPANY_LOGO_SUCCESS',
      getCompanyLogo,
    });
    return addCompanyLogo;
  } catch (error) {
    dispatch({
      type: 'GET_COMPANY_LOGO_FAILURE',
      error,
    });
  }
};

export const getTemplateEmailList = (token, cid) => async dispatch => {
  const api = new Api(token);
  dispatch({
    type: 'GET_TEMPLATE_EMAIL_LIST',
  });
  try {
    const getTemplateEmailList = await api.companies.getTemplateEmailList(cid);
    dispatch({
      type: 'GET_TEMPLATE_EMAIL_LIST_SUCCESS',
      getTemplateEmailList,
    });
    return getTemplateEmailList;
  } catch (error) {
    dispatch({
      type: 'GET_TEMPLATE_EMAIL_LIST_ERROR',
      error,
    });
  }
};

export const addTemplate = (token, cid, templateName, text) => async dispatch => {
  const api = new Api(token);
  dispatch({
    type: 'ADD_TEMPLATE',
  });
  try {
    const addTemplate = await api.companies.addTemplate(cid, templateName, text);
    dispatch({
      type: 'ADD_TEMPLATE_SUCCESS',
      addTemplate,
    });
    return addTemplate;
  } catch (error) {
    dispatch({
      type: 'ADD_TEMPLATE_ERROR',
      error,
    });
  }
};

export const getRowTemplate = (token, cid, tid) => async dispatch => {
  const api = new Api(token);
  dispatch({
    type: 'GET_ROW_TEMPLATE',
  });
  try {
    const rowTemplate = await api.companies.getRowTemplate(cid, tid);
    dispatch({
      type: 'GET_ROW_TEMPLATE_SUCCESS',
      rowTemplate,
    });
    return rowTemplate;
  } catch (error) {
    dispatch({
      type: 'GET_ROW_TEMPLATE_ERROR',
      error,
    });
  }
};

export const updateTemplate = (token, cid, tid, templateName, text) => async dispatch => {
  const api = new Api(token);
  dispatch({
    type: 'UPDATE_TEMPLATE',
  });
  try {
    const updateTemplate = await api.companies.updateTemplate(cid, tid, templateName, text);
    dispatch({
      type: 'UPDATE_TEMPLATE_SUCCESS',
      updateTemplate,
    });
    return updateTemplate;
  } catch (error) {
    dispatch({
      type: 'UPDATE_TEMPLATE_ERROR',
      error,
    });
  }
};

export const deleteTemplate = (token, cid, tid) => async dispatch => {
  const api = new Api(token);
  dispatch({
    type: 'DELETE_TEMPLATE',
  });
  try {
    const deleteTemplate = await api.companies.deleteTemplate(cid, tid);
    dispatch({
      type: 'DELETE_TEMPLATE_SUCCESS',
      deleteTemplate,
    });
    return deleteTemplate;
  } catch (error) {
    dispatch({
      type: 'DELETE_TEMPLATE_ERROR',
      error,
    });
  }
};

export const applyTemplate = (token, cid, tid, pid, text) => async dispatch => {
  const api = new Api(token);
  dispatch({
    type: 'APPLY_TEMPLATE',
  });
  try {
    const applyTemplate = await api.companies.applyTemplate(cid, tid, pid, text);
    dispatch({
      type: 'APPLY_TEMPLATE_SUCCESS',
      applyTemplate,
    });
    return applyTemplate;
  } catch (error) {
    dispatch({
      type: 'APPLY_TEMPLATE_ERROR',
      error,
    });
  }
};

export const applyTemplateForEdit = (token, cid, tid, pid, text) => async dispatch => {
  const api = new Api(token);
  dispatch({
    type: 'APPLY_TEMPLATE_FOR_EDIT',
  });
  try {
    const applyTemplateForEdit = await api.companies.applyTemplate(cid, tid, pid, text);
    dispatch({
      type: 'APPLY_TEMPLATE_FOR_EDIT_SUCCESS',
      applyTemplateForEdit,
    });
    return applyTemplateForEdit;
  } catch (error) {
    dispatch({
      type: 'APPLY_TEMPLATE_FOR_EDIT_ERROR',
      error,
    });
  }
};
